export default __webpack_public_path__ + "fonts/4877b36969394cacae5fe444d8b8a3ee.svg";